var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtlas = function SvgAtlas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#atlas_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "atlas_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0v18h18V0Z",
    fill: "#fff",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.969 3.767a5.327 5.327 0 1 0 5.327 5.327 5.333 5.333 0 0 0-5.327-5.327Zm4.488 4.917h-2.04c-.092-1.87-.812-3.192-1.403-3.975a4.517 4.517 0 0 1 3.443 3.975Zm-6.115.82h3.254c-.118 2.13-1.139 3.437-1.627 3.943-.49-.507-1.51-1.813-1.627-3.943Zm0-.82C7.46 6.553 8.48 5.247 8.969 4.74c.489.509 1.509 1.815 1.627 3.944H7.342Zm2.672 4.794c.59-.782 1.31-2.104 1.402-3.974h2.041a4.517 4.517 0 0 1-3.443 3.974Z",
    fill: "#000",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.647 15.267a.22.22 0 0 1-.07.16.244.244 0 0 1-.167.066H8.72a.243.243 0 0 1-.167-.066.22.22 0 0 1-.07-.16.22.22 0 0 1 .07-.16.243.243 0 0 1 .167-.066h.237v-1.805a.22.22 0 0 1 .07-.16.243.243 0 0 1 .167-.066h.711c.063 0 .124.024.168.067.044.042.07.1.07.16v1.804h.473v-3.159a.22.22 0 0 1 .07-.16.243.243 0 0 1 .168-.066h.947c.063 0 .124.024.168.067.045.042.07.1.07.16v3.159h.474v-4.514a.22.22 0 0 1 .069-.16.243.243 0 0 1 .168-.066h1.185c.063 0 .123.024.167.067.045.042.07.1.07.16v4.512h.237c.063 0 .123.024.167.067.045.042.07.1.07.16Z",
    fill: "#000",
    style: {
      fill: "#000"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#atlas_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z",
    fill: "#ABB0BB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.158 13.236c0-.285.12-.55.319-.74.197-.187.456-.285.718-.285v.8a.245.245 0 0 0-.168.066.22.22 0 0 0-.069.16v1.805h-.236l-.047.004a.24.24 0 0 0-.121.061.22.22 0 0 0 0 .32.241.241 0 0 0 .12.061l.048.005h5.687l.047-.005a.24.24 0 0 0 .121-.061.221.221 0 0 0 .065-.116l.005-.044a.221.221 0 0 0-.07-.16.241.241 0 0 0-.12-.061l-.048-.004h-.236v-4.514a.22.22 0 0 0-.07-.16.244.244 0 0 0-.168-.066v-.8c.23 0 .458.077.643.221l.077.066.07.075c.156.181.248.415.248.664v3.877c.027.017.053.037.079.057l.077.066.07.074a1.018 1.018 0 0 1-.07 1.405 1.044 1.044 0 0 1-.72.286H8.722c-.263 0-.523-.099-.72-.286a1.023 1.023 0 0 1-.313-.634l-.004-.106.004-.106c.026-.244.14-.468.313-.633l.077-.066a1.02 1.02 0 0 1 .08-.056v-1.17Zm1.66-1.353c0-.285.118-.55.317-.74l.077-.066c.185-.145.413-.22.643-.22v.8l-.047.004a.242.242 0 0 0-.121.061.222.222 0 0 0-.07.16v3.16h-.473v-1.806a.22.22 0 0 0-.07-.16.244.244 0 0 0-.168-.066h-.71v-.8h.621v-.327Zm1.896-1.355c0-.285.119-.55.317-.74l.077-.065c.186-.144.413-.22.643-.22v.8l-.047.003a.242.242 0 0 0-.121.063.22.22 0 0 0-.07.16v4.513h-.474v-3.16a.221.221 0 0 0-.07-.16.242.242 0 0 0-.166-.065h-.949v-.8h.86v-.329Zm2.221-1.025v.8h-1.184v-.8h1.184Z",
    fill: "#ABB0BB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "atlas_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAtlas;